import { render, staticRenderFns } from "./AccountArticleLicences.vue?vue&type=template&id=486cd42f&"
import script from "./AccountArticleLicences.vue?vue&type=script&lang=ts&"
export * from "./AccountArticleLicences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports